import type { JSX } from "react";
import { Button } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { Container } from "app/components/SharingModal/components/Footer/Footer.styled";
import type { IValidatedEmailError } from "app/components/SharingModal/types";

interface IFooterBaseProps {
    onClose: VoidFunction;
    isLoadingSharing: boolean;
    shareButtonText: string;
    emailError?: IValidatedEmailError | null;
    hasCancelButton?: boolean;
    isEmailValidating?: boolean;
}

interface IFooterInviteProps extends IFooterBaseProps {
    isSharingView: true;
    onInvite: VoidFunction;
    onCancel: VoidFunction;
}

interface IFooterSaveCloseProps extends IFooterBaseProps {
    isSharingView?: false;
}

type IFooterProps = IFooterInviteProps | IFooterSaveCloseProps;

export const Footer = ({
    isLoadingSharing,
    onClose,
    shareButtonText,
    emailError = null,
    hasCancelButton = true,
    isEmailValidating = false,
    ...rest
}: IFooterProps): JSX.Element => {
    const isSharingView = rest.isSharingView === true;
    const onInvite = isSharingView ? rest.onInvite : undefined;
    const onCancel = isSharingView ? rest.onCancel : undefined;

    const handleClick = (): void => {
        isSharingView && onInvite ? onInvite() : onClose();
    };

    const isBtnDisabled = isLoadingSharing || Boolean(emailError) || isEmailValidating;

    return (
        <Container
            isDisabled={isBtnDisabled}
            justifyContent="end"
        >
            {isSharingView && hasCancelButton ? (
                <Button
                    type={"flat"}
                    onClick={onCancel}
                >
                    {translate("asset.sharing.footer.cancel")}
                </Button>
            ) : null}
            <Button
                onClick={handleClick}
                isLoading={isLoadingSharing}
                isDisabled={isBtnDisabled}
                className="send-invite-btn"
            >
                {shareButtonText}
            </Button>
        </Container>
    );
};
